// extracted by mini-css-extract-plugin
export var alignLeft = "x_rd d_fp d_bG d_dv";
export var alignCenter = "x_bP d_fq d_bD d_dw";
export var alignRight = "x_rf d_fr d_bH d_dx";
export var contactFormWrapper = "x_hh d_hh d_bT d_b5";
export var contactFormText = "x_sL";
export var inputFlexColumn = "x_sM";
export var inputFlexRow = "x_sN";
export var contactForm = "x_hd d_hd d_w d_bJ";
export var contactFormHeader = "x_hj d_hj d_cZ d_c3";
export var contactFormParagraph = "x_hk d_hk d_cV d_c3";
export var contactFormSubtitle = "x_hl d_hl d_cW d_c3";
export var contactFormLabel = "x_hg d_hg d_w d_by";
export var contactFormInputSmall = "x_hq d_hq d_w d_b3 d_b5";
export var contactFormInputNormal = "x_hr d_hr d_w d_b3 d_b5";
export var contactFormInputLarge = "x_hs d_hs d_w d_b3 d_b5";
export var contactFormTextareaSmall = "x_hm d_hm d_w d_b3 d_b5";
export var contactFormTextareaNormal = "x_hn d_hn d_w d_b3 d_b5";
export var contactFormTextareaLarge = "x_hp d_hp d_w d_b3 d_b5";
export var contactRequiredFields = "x_ht d_ht d_w d_bz";
export var inputField = "x_sP";
export var inputOption = "x_sQ";
export var inputOptionRow = "x_sR";
export var inputOptionColumn = "x_sS";
export var radioInput = "x_sT";
export var select = "x_r6";
export var contactBtnWrapper = "x_sV d_d3 d_d1 d_w d_bz d_bD";
export var sending = "x_sW";
export var blink = "x_sX";